import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ProgramStore from '../../../app/store/ProgramStore';
import { PROGRAM_RESPONSES_RECEIVED } from '../../../app/store/actions';

class LoadCurrentProgramResponses extends React.Component {
    componentDidMount() {
        const { currentProgramId, currentProgramResponsesLoaded } = this.props;

        if (currentProgramId && !currentProgramResponsesLoaded) {
            this.loadResponses(currentProgramId);
        }
    }

    componentDidUpdate(prevProps) {
        const { currentProgramId, currentProgramResponsesLoaded } = this.props;

        if (currentProgramId && currentProgramId !== prevProps.currentProgramId && !currentProgramResponsesLoaded) {
            this.loadResponses(currentProgramId);
        }
    }

    loadResponses(patientProgramId) {
        this.props.getProgramResponses(patientProgramId,
            {
                reducerParams: {
                    patientProgramId,
                },
            });
    }

    render() {
        return null;
    }
}

LoadCurrentProgramResponses.propTypes = {
    getProgramResponses: PropTypes.func.isRequired,
    currentProgramResponsesLoaded: PropTypes.bool,
    currentProgramId: PropTypes.string,
};

LoadCurrentProgramResponses.defaultProps = {
    currentProgramResponsesLoaded: false,
    currentProgramId: null,
};

const mapStateToProps = state => ({
    currentProgramId: state.programStore.currentProgram ? state.programStore.currentProgram.id : null,
    currentProgramResponsesLoaded: Boolean(state.programStore.requests[PROGRAM_RESPONSES_RECEIVED]
        && state.programStore.requests[PROGRAM_RESPONSES_RECEIVED].completed),
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(ProgramStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadCurrentProgramResponses);
